<template>
  <div class="home">
    <a-list class="list">
      <template slot="header">
        <div class="top_bar">
          <div class="title_bar">
            <a href="//oa.139tm.com" class="home-link">
              <el-button icon="el-icon-back" type="text">首页</el-button>
            </a>
            <div class="system_name">{{ systemName }}</div>
          </div>
          <div class="toolbar">
            <el-input
              class="toolbar-input"
              placeholder="搜索姓名、电话、ID"
              v-model="filter_form.keyword"
              clearable
              size="small"
              @change="search"
            >
              <el-button
                class="filter_button"
                slot="append"
                @click="filter_box = true"
                icon="el-icon-search"
              ></el-button>
            </el-input>
            <div class="toolbar-actions">
              <span class="total-count">共 <span class="danger">{{ total }}</span> 条</span>
              <el-button icon="el-icon-refresh" type="text" size="mini" @click="reset">刷新</el-button>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="bottom-bar">
          <cube-tab-bar
            v-model="selectedLabelDefault"
            @click="tabHandler"
            :data="tabs"
          ></cube-tab-bar>
        </div>
      </template>
      <DynamicScroller
        ref="wrapper"
        class="dy-scroll"
        style="height: calc(100vh - 152px)"
        :items="current_data"
        :min-item-size="1"
        key-field="id"
        v-infinite-scroll="nextPage"
        :infinite-scroll-disabled="this.page === this.last_page"
        infinite-scroll-distance="10"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :size-dependencies="[item.name]"
            :data-index="index"
          >
            <div class="title" @click="goInfo(item.id)">
              <div class="brand">
                <span v-text="item.name" class="name"></span>
              </div>
              <div class="status">
                <span class="brand_bg" v-if="item.origin_type === 'online'"
                >网</span
                >
                <span class="success_bg" v-if="item.order_num > 0">订</span>
                <span
                  v-if="item.progress_status > 0"
                  :class="{
                    danger_bg: item.progress_status === 1,
                    warning_bg: item.progress_status === 2,
                    info_bg: item.progress_status === 3
                  }"
                >{{ item.progress_status_text.short }}</span
                >
              </div>
            </div>
            <div class="desc">
              <div class>
                <template v-if="item.records && item.records.length > 0">
                  <span>{{ item.records[0].occur_time }}</span>
                  <span>{{ item.records[0].creator['name'] }}</span
                  >:
                  <span>{{ item.records[0].content | formatDesc(50) }}</span>
                </template>
              </div>
            </div>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
      <a-spin v-if="loading"/>
    </a-list>

    <el-drawer
      :destroy-on-close="true"
      title="按条件筛选"
      :visible.sync="filter_box"
      direction="ltr"
      :with-header="true"
      custom-class="filter_box"
      ref="filter_box"
      size="95%"
    >
      <div class="filter_box_content">
        <div class="title">按条件筛选客户</div>
        <el-form :model="filter_form" @submit.native.prevent>
          <!--取消该状态筛选-->
          <el-form-item label="状态" :label-width="formLabelWidth" v-if="false">
            <template v-for="(d, index) in progress_status">
              <span
                :class="{
                  filter_span: true,
                  cur: filter_form.progress_status === index
                }"
                :key="index"
                @click="filter_form.progress_status = filter_form.progress_status === index ? '' : index"
                v-if="index < 4 && index > 0"
              >{{ d.full }}</span
              >
            </template>
          </el-form-item>
          <!--取消结束-->

          <el-form-item label="订单" :label-width="formLabelWidth">
            <span
              :class="{
                filter_span: true,
                cur: filter_form.has_order === true
              }"
              @click="filter_form.has_order = !filter_form.has_order"
            >有订单</span
            >
          </el-form-item>
          <el-form-item label="单数" :label-width="formLabelWidth" v-if="filter_form.has_order">
            <span class="filter_span" :class="{cur: filter_form.order_num === 1}"
                  @click="filter_form.order_num = filter_form.order_num ===1 ? '' : 1">1单</span>
            <span class="filter_span" :class="{cur: filter_form.order_num === 2}"
                  @click="filter_form.order_num = filter_form.order_num ===2 ? '' : 2">2单</span>
            <span class="filter_span" :class="{cur: filter_form.order_num === 999}"
                  @click="filter_form.order_num = filter_form.order_num ===999 ? '' : 999">2单以上</span>
          </el-form-item>

          <el-form-item label="等级" :label-width="formLabelWidth">
            <template v-for="level in customerLevelList">
             <span class="filter_span" :class="{cur: filter_form.customer_level_id === level.id}"
                   v-text="level.name"
                   :key="level.id"
                   @click="
                filter_form.customer_level_id =
                  filter_form.customer_level_id === level.id ? '' : level.id
              "
             ></span>
            </template>
          </el-form-item>

          <el-form-item label="复购" :label-width="formLabelWidth">
            <span class="filter_span" :class="{cur: filter_form.repurchase === 1}"
                  @click="filter_form.repurchase = filter_form.repurchase ===1 ? '' : 1">可复购</span>
            <span class="filter_span" :class="{cur: filter_form.repurchase === 0}"
                  @click="filter_form.repurchase = filter_form.repurchase ===0 ? '' : 0">不可复购</span>
          </el-form-item>

          <!--取消该筛选功能-->
          <el-form-item label="来源" :label-width="formLabelWidth" v-if="false">
            <span
              :class="{
                filter_span: true,
                cur: filter_form.origin_type === o.val
              }"
              v-for="o in origins"
              v-text="o.k"
              :key="o.val"
              @click="
                filter_form.origin_type =
                  filter_form.origin_type === o.val ? '' : o.val
              "
            ></span>
          </el-form-item>
          <!--取消结束-->

          <el-form-item label="开始" :label-width="formLabelWidth">
            <el-date-picker
              v-model="filter_form.start"
              :editable="false"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束" :label-width="formLabelWidth">
            <el-date-picker
              v-model="filter_form.end"
              type="date"
              :editable="false"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="城市" :label-width="formLabelWidth">
            <el-cascader
              fillable
              clearable
              :props="{ expandTrigger: 'hover' }"
              size="large"
              :options="options"
              v-model="selectedOptions"
              @change="handleChange"
            ></el-cascader>
          </el-form-item>
          <div class="filter_box_footer">
            <el-button @click="reset">重 置</el-button>
            <el-button
              tabindex="0"
              type="primary"
              @click="search"
              :autofocus="true"
            >确 定
            </el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import { CodeToText, provinceAndCityDataPlus } from 'element-china-area-data'
import customer from '../api/customer'
import Customer from '../api/customer';
import { CONFIG } from '../config'

export default {
  name: 'home',
  components: { DynamicScroller, DynamicScrollerItem },
  directives: { infiniteScroll },
  activated () {
    this.$el.querySelector('.dy-scroll').scrollTop = this.position
    this.filter_form = this.$store.getters.getFilterParams
  },
  mounted () {
    this.filter_form = this.$store.getters.getFilterParams
    this.get_customers()
    this.listCustomerLevel()
    this.getProgressStatus()
  },
  data: function () {
    return {
      selectedLabelDefault: 'home', // 默认选择tab
      // tab列表
      tabs: [
        {
          value: 'add',
          label: '添加',
          icon: 'el-icon-plus'
        },
        {
          value: 'home',
          label: '列表',
          icon: 'el-icon-s-fold'
        },
        {
          value: 'user',
          label: '统计',
          icon: 'cubeic-person'
        }
      ],
      last_page: 1,
      total: 0, // 总条数
      filter_box: false,
      options: provinceAndCityDataPlus,
      loading: false,
      progress_status: [],
      origins: [
        { k: '线上', val: 'online' },
        { k: '线下', val: 'offline' }
      ],
      filterStore: {},
      formLabelWidth: '50px',
      selectedOptions: [],
      current_data: [],
      customerLevelList: [],
      position: 0,
      filter_form: {}
    }
  },
  methods: {
    search () {
      this.$store.dispatch('storeParams', this.filter_form)
      this.$refs.filter_box.closeDrawer()
      this.page = 1
      this.position = 0
      this.$el.querySelector('.dy-scroll').scrollTop = this.position
      this.get_customers()
    },
    tabHandler (value) {
      this.$router.push({ name: value })
    },
    nextPage () {
      if (this.loading || this.page === this.last_page) {
        return
      }
      this.page++
      this.get_customers()
    },
    handleChange (value) {
      this.filter_form.province = CodeToText[this.selectedOptions[0]]
      this.filter_form.city = CodeToText[this.selectedOptions[1]]
      return value
    },
    reset () {
      this.filter_form = {
        staff_id: '',
        period: '',
        progress_status: '',
        origin_type: '',
        start: '',
        end: '',
        keyword: '',
        province: '',
        city: '',
        order_num: '',
        repurchase: '',
        customer_level_id: '',
        has_order: false
      }
      this.$store.dispatch('storeParams', this.filter_form)
      this.selectedOptions = []
      this.page = 1
      this.get_customers()
      this.position = 0
      this.$el.querySelector('.dy-scroll').scrollTop = this.position
      this.$refs.filter_box.closeDrawer()
    },
    get_customers () {
      this.loading = true
      let params = this.filter_form
      customer.get_customers(this.page, params).then(res => {
        if (res.data.code !== 1) {
          this.loading = false
          this.reset()
          localStorage.setItem('is_login', 0)
          this.$router.push('/login')
          return
        }
        this.loading = false
        let _data = { ...res.data.data }

        this.total = _data.total
        this.page = _data.current_page
        this.last_page= _data.last_page


        let _currentData = [...this.current_data]

        if (this.page > 1) {
          _currentData.push(..._data.data)
        } else {
          _currentData = [..._data.data]
        }
        this.current_data = _currentData
      })
    },
    listCustomerLevel () {
      Customer.get_customer_levels().then(res => {
        this.customerLevelList = res.data.data
      })
    },
    goInfo (id) {
      this.position = this.$el.querySelector('.dy-scroll').scrollTop
      this.$router.push('/info/' + id)
    },
    getProgressStatus () {
      customer.get_progress_status().then(res => {
        this.progress_status = res.data.data
      })
    }
  },
  computed: {
    systemName () {
      return CONFIG.SYSTEM_NAME
    },
    //  当前页
    page: {
      get () {
        return this.$store.state.home.page
      },
      set (value) {
        this.$store.commit('setPage', value)
      }
    }
  },
  filters: {
    formatDesc: function (value, num) {
      return value.slice(0, num)
    },
    formatDate (value) {
      if (value && value.length > 10) {
        return value.slice(5, 10)
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
$max-width: 600px;

.home {
  margin: 0 8px;

  .ant-list-header {
    padding-top: 0;
    padding-bottom: 0;
    height: 96px;

    .top_bar {
      position: fixed;
      top: 0;
      width: calc(100vw - 16px);
      z-index: 1;
      background-color: #fff;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

      .title_bar {
        display: flex;
        align-items: center;
        padding: 8px 0 4px 0;

        .home-link {
          text-decoration: none;
          flex-shrink: 0;
        }

        .system_name {
          flex: 1;
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          color: #303133;
          margin-right: 50px;
        }
      }

      .toolbar {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 0;

        .toolbar-input {
          flex: 1;
          min-width: 0;
        }

        .toolbar-actions {
          display: flex;
          align-items: center;
          gap: 2px;
          flex-shrink: 0;
          white-space: nowrap;

          .total-count {
            font-size: 12px;
            color: #606266;
          }

          .el-button {
            padding: 4px 6px;
            font-size: 12px;
          }
        }
      }
    }
  }

  .ant-list-footer {
    height: 56px;

    .bottom-bar {
      margin-left: -8px;
      margin-right: -8px;
    }

    .cube-tab-bar {
      position: fixed;
      bottom: 0;
      width: 100%;
      max-width: $max-width;
      background-color: #fff;

      .cube-tab {
        i {
          font-size: 22px;
          line-height: 1;
        }

        .el-icon-plus {
          font-weight: bold;
        }

        div {
          font-size: 12px;
        }
      }

      .cube-tab_active {
        color: #409eff;
      }
    }
  }

  .filter_box_content {
    padding: 0 20px;

    .title {
      padding: 10px 0 15px 0;
      color: #409eff;
      font-size: 14px;
    }

    .el-date-editor,
    .el-cascader {
      width: 100%;
    }

    .filter_span {
      color: #2c3e50;
      padding: 0 10px;
      margin: 2px;
      font-size: 14px;
      cursor: pointer;
      display: inline-block;
      background: #ececea;
      border-radius: 1px;
    }

    .filter_span.cur {
      color: #fff;
      background: #409eff;
    }
  }

  .filter_box_footer {
    text-align: center;
  }

  .ant-list.list {
    list-style: none;
    padding: 0;
    text-align: left;

    .vue-recycle-scroller__item-view {
      border-bottom: 1px solid #dcdfe6;

      .title {
        padding-top: 6px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
      }
    }
  }

  .title .name {
    font-size: 18px;
  }

  .desc {
    font-size: 13px;
    color: #909399;
    padding-top: 5px;
    padding-bottom: 6px;
  }

  .status span {
    display: inline-block;
    text-align: center;
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 20px;
    margin: 0 2px;
    font-size: 12px;
    color: #fff;
  }

  .el-drawer__wrapper .el-drawer__container .filter_box {
    height: auto;
    min-height: 100%;
    overflow: scroll;
  }
}
</style>